// extracted by mini-css-extract-plugin
export var info = "style-module--info--d74f5";
export var mainList = "style-module--main-list--6c927";
export var prof = "style-module--prof--943a4";
export var reg = "style-module--reg--24147";
export var speakers = "style-module--speakers--ed2ed";
export var wrap = "style-module--wrap--3bd96";